import { render, staticRenderFns } from "./MyPerson.vue?vue&type=template&id=3816bef5&scoped=true"
import script from "./MyPerson.vue?vue&type=script&lang=js"
export * from "./MyPerson.vue?vue&type=script&lang=js"
import style0 from "./MyPerson.vue?vue&type=style&index=0&id=3816bef5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3816bef5",
  null
  
)

export default component.exports